import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {encryptStorage} from '../../CustomStorage';
import { APP_CONSTANTS,SOUNDBOX_APP_CONSTANTS } from '../../URLConstants';
import {GetTerritoryStructure,GetSounBoxAppSettings  } from '../../network/AppLevel';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [sessionUserData, setSessionUserData] = useState(encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_DATA));
  const [organzationClientId, setOrganzationClientId] = useState('');
  const [audioCubeAppLevelSettings,setAudioCubeAppLevelSettings]=useState({})
  const [organizationAudioCubeTerritories,setOrganizationAudioCubeTerritories]=useState([])

  const navigate = useNavigate();

  const authenticateSession = (adminData) => {
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, true);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, adminData?.token);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, adminData);
    setSessionUserData(adminData) 

    getAppLevelSettings()
    getAudioCubeOrganizationTerritories(adminData?.user?.role===APP_CONSTANTS.USER_ROLE_SUPER_ADMIN? "": adminData?.user?.organization?.id)

  };

  const logoutSession = () => {

    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, null);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, null);
    setSessionUserData(null);
    setOrganzationClientId(null)
    setOrganizationAudioCubeTerritories(organizationAudioCubeTerritories=>[])
    navigate('/', { replace: true });
  
  };

  const getAppLevelSettings = () =>{
      GetSounBoxAppSettings().then((res)=>{
        setAudioCubeAppLevelSettings(res?.data?.data)
      }).catch((err)=>{

      })
  }

  const getAudioCubeOrganizationTerritories=(organizationId)=>{
    GetTerritoryStructure(organizationId).then((res)=>{
      setOrganizationAudioCubeTerritories(res?.data?.data)
    }).catch((err)=>{

    })
}

  return (
    <AuthContext.Provider value={{  sessionUserData,organzationClientId,audioCubeAppLevelSettings,organizationAudioCubeTerritories,authenticateSession, logoutSession,getAppLevelSettings,getAudioCubeOrganizationTerritories }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
